module.exports = __webpack_public_path__ + "static/media/mini-logo.d5f902a6.webp";